/**
 * «Bajar resultados (CSV)» en el detalle de una campaña: una fila por mensaje, con su estado, el motivo, las horas, si
 * respondió, si tocó el link, si se dio de baja y lo que costó (`GET /campanas/:id/exportar`). Lo ven el equipo y una
 * persona de un cliente: qué trae el archivo lo decide el backend (al cliente, el celular enmascarado y lo que se le
 * cobra a la marca, nunca lo que le cuesta a Deenex). Acá sólo se baja, con el mismo `descargarBinario` que los Excel y
 * los PDF de Activa.
 */

import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { oficialApi } from "../api";
import { leerError, textoError } from "../logic/respuesta";

/** `descargarBinario` lanza un Error con el texto del backend (o el genérico de su status); un corte de red, un TypeError. */
function textoDelFallo(e: unknown): string {
  if (e instanceof Error && !(e instanceof TypeError) && e.message.trim()) return e.message.trim();
  return textoError(leerError(e));
}

export function BajarResultadosCampana({ campanaId }: { campanaId: string }) {
  const [bajando, setBajando] = useState(false);
  const [error, setError] = useState("");

  const bajar = async () => {
    setBajando(true);
    setError("");
    try {
      await oficialApi.exportarResultados(campanaId);
    } catch (e) {
      setError(`No pudimos bajar los resultados. ${textoDelFallo(e)}`);
    } finally {
      setBajando(false);
    }
  };

  return (
    <div className="flex flex-col items-end gap-1">
      <button type="button" onClick={() => void bajar()} disabled={bajando}
        title="Un renglón por persona: estado, motivo, horas, respuestas, clics, bajas y costo"
        className="h-9 px-3 rounded-lg border border-slate-200 bg-white text-xs font-semibold text-slate-700 hover:bg-slate-50 inline-flex items-center gap-1.5 disabled:opacity-50">
        {bajando ? <Loader2 size={13} className="animate-spin" /> : <Download size={13} />}
        {bajando ? "Bajando…" : "Bajar resultados (CSV)"}
      </button>
      {error && <p className="max-w-xs text-right text-xs text-red-700" role="alert">{error}</p>}
    </div>
  );
}

export default BajarResultadosCampana;
